import React, { useState } from "react";
import clsx from "clsx";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "../styles";

const RequestMonitorSettingsForm = ({ onRequestMonitorThresholdsClicked }) => {
  const classes = useStyles();
  const [settingsExpanded, setSettingsExpanded] = useState(true);

  const toggleSettingsExpanded = () => {
    setSettingsExpanded(!settingsExpanded);
  };

  return (
    <Grid
      container
      className={classes.panelRoot}
      data-testid="request-monitor-panel"
    >
      <Accordion
        data-tag="requestMonitorSettings"
        expanded={settingsExpanded}
        TransitionProps={{ unmountOnExit: true }}
        className={classes.fullWidthAccordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={toggleSettingsExpanded}
        >
          <Typography className={classes.heading}>
            Request Monitor
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Button
                className={clsx(["RequestMonitorBtn"])}
                data-testid="requestMonitorBtn"
                variant="contained"
                fullWidth
                color="primary"
                onClick={onRequestMonitorThresholdsClicked}
              >
                Request Monitor Thresholds
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default RequestMonitorSettingsForm;
